import api from "../../utils/apiUser";

export const getPermisos = async () => {
  const res = await api.get("/api/permisos");
  return res.data; 
};

export const createPermiso = async (data) => {
  const res = await api.post("/api/permisos", data);
  return res.data;
};

export const updatePermiso = async (id, data) => {
  const res = await api.put(`/api/permisos/${id}`, data);
  return res.data;
};

export const getPermisosByRol = async (rol_id) => {
  const res = await api.get(`/api/roles/permisos/${rol_id}`);
  return res.data;
};

export const assignPermisosToRol = async (rol_id, permisos) => {
  const res = await api.post(`/api/roles/permisos/${rol_id}`, { permisos });
  return res.data;
};